// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__3pLG_"};